export default function getMultipleLanguageCountries(state) {
    if (state.countries) {
        const countryISOCodes = Object.keys(state.countries)
            .filter((country) => Object.keys(state.countries[country].languages).length > 1)
            .reduce((acc, currentISOCode) => {
                const currentCountryObject = state.countries[currentISOCode]
                const currentCountryLangs = Object.keys(currentCountryObject.languages).map(
                    (lang) => currentCountryObject.languages[lang].locale
                )

                acc[currentISOCode] = currentCountryLangs

                return acc
            }, {})

        return { multipleLanguageCountries: countryISOCodes }
    } else {
        return {}
    }
}
